import LinkedLabelValuePair from "@/models/LinkedLabelValuePair";
import axiosHelper from "../axiosHelper";
import ServiceJobComponentGroupModel from "@/models/ServiceJobComponentGroupModel";
import ServiceJobComponentModel from "@/models/ServiceJobComponentModel";
import { AxiosInstance } from "axios";
import ServiceJobModel from "@/models/ServiceJobModel";

export default class JobComponentsApiHelper {

	_url = '/api/servicejobcomponents';

	groupedJobComponentsHttpClient: AxiosInstance;
	getComponentDefJobHttpClient: AxiosInstance;

	constructor(jwt: string) {
		this.groupedJobComponentsHttpClient = axiosHelper.createInstance(jwt);
		this.getComponentDefJobHttpClient = axiosHelper.createInstance(jwt);
	}
	
    async fetchJobComponentsGroupedAsync(): Promise<Array<LinkedLabelValuePair<string, number>>> {
		try {
			const response = await this.groupedJobComponentsHttpClient.get(`${this._url}/grouped`);
			const groupedComponents = new Array<LinkedLabelValuePair<string, number>>();

			response.data.map((op: ServiceJobComponentGroupModel) => {
				if (!op.id &&
					op.components?.length) {					
					op.components.map((_: ServiceJobComponentModel) => { 
						groupedComponents.push(new LinkedLabelValuePair({
							label: _.name,
							value: _.id
						}));
					});
				} else {
					groupedComponents.push(new LinkedLabelValuePair({
						label: op.name,
						value: 0,
						children: op.components!.map((_: ServiceJobComponentModel) => new LinkedLabelValuePair({
								label: _.name,
								value: _.id
							}))
					}));
				}
			});
			return groupedComponents;			
		} catch (e: any) {
			console.error('Error loading jobs grouped components', e);
            return new Array<any>();
		}
	}

	/** get a single default-job of a component */
	async getDefaultJobAsync(componentId: number): Promise<ServiceJobModel | null> {
		try {
			const jobsResponse = await this.getComponentDefJobHttpClient.get(`${this._url}/default-job/${componentId}`);	
			const defaultJob = new ServiceJobModel(jobsResponse.data);
			return defaultJob;
		} catch (e) {			
			console.error(`Error getting component's #${componentId} default job`, e);
			return null;
		}
	}
}